import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ImportEntity } from 'src/app/import/entities/ImportEntity';
import { ImportService } from '../../import/services/import.service';

@Component({
  selector: 'app-import-entity-detail',
  templateUrl: './import-entity-detail.component.html',
  styleUrls: ['./import-entity-detail.component.scss']
})
export class ImportEntityDetailComponent implements OnInit {

	@Input() importEntity: ImportEntity;
	fieldKeys: string[] = [];

	constructor(private importService: ImportService, public activeModal: NgbActiveModal, private toastManager: ToastrService, private translate: TranslateService) { }

	ngOnInit() {
		this.importService.getImportEntity(this.importEntity.id).subscribe(importEntity => {
			this.importEntity = importEntity;
			this.fieldKeys = Object.keys(this.importEntity.fields);
		}, err => {
			this.translate.get('import.errors.import_entity_details_not_loaded').subscribe((res: string) => {
				this.toastManager.error(res);
				this.activeModal.close();
			});
		});
	}
}
